<template>
  <div id="app">
    <app-header/>
    <router-view/>
  </div>
</template>

<script>
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    'app-header': Header
  }
}
</script>

<style lang="scss">
@import "./assets/styles/config.scss";
* {
  box-sizing: border-box;
  margin: 0;
}

body {
  color: set-text-color($primary-color);
  padding: 0;
  font-family: 'Montserrat', sans-serif;
}

.text-secondary {
  color: $secondary-color;
}
@import "./assets/styles/mobile.scss"
</style>
